module.exports = __webpack_public_path__ + "img/11_4.1ce18cc3.png";